import { useEffect, useState } from "react";
import type { FavoriteItemTypeEnum } from "@graphql/__generated__/types";

export type FavoriteItem = {
  type: FavoriteItemTypeEnum;
  id: number;
};

export const useFavoriteTeamModalSelection = (props: {
  initialItems: FavoriteItem[];
  maxItems: number;
}) => {
  const [items, setItems] = useState<FavoriteItem[]>([]);

  const clickHandler = (type: FavoriteItemTypeEnum, id: number) => {
    const existingIndex = items.findIndex(
      (item) => item.type === type && item.id === id
    );
    if (existingIndex >= 0) {
      setItems(items.filter((_, i) => i !== existingIndex));
      return;
    }

    if (items.length >= props.maxItems) {
      return;
    }

    setItems([...items, { type, id }]);
  };

  const clear = () => {
    setItems([]);
  };

  const isClearable = items.length > 0;

  const getSelectionIndex = (type: FavoriteItemTypeEnum, id: number) =>
    items.findIndex((item) => item.type === type && item.id === id);

  useEffect(() => {
    if (items.length > 0) {
      return;
    }
    setItems(props.initialItems);
  }, [props.initialItems]);

  return {
    items,
    clickHandler,
    clear,
    isClearable,
    getSelectionIndex,
  };
};
